// extracted by mini-css-extract-plugin
export var centered = "ContentSection-module__centered___w17xS";
export var content = "ContentSection-module__content___IbQHU";
export var icon = "ContentSection-module__icon___-HLzg";
export var imageContainer = "ContentSection-module__imageContainer___M+BfA";
export var left = "ContentSection-module__left___CBnbe";
export var reverse = "ContentSection-module__reverse___aNGl6";
export var right = "ContentSection-module__right___kdlpz";
export var row = "ContentSection-module__row___09Mew";
export var section = "ContentSection-module__section___Ul21F";